// extracted by mini-css-extract-plugin
export var author = "basic-slide-module--author--9b31e";
export var image = "basic-slide-module--image--960c4";
export var imageColumn = "basic-slide-module--imageColumn--865e5";
export var preContent = "basic-slide-module--preContent--4c8b3";
export var quote = "basic-slide-module--quote--2184d";
export var textOverImage = "basic-slide-module--textOverImage--81328";
export var title = "basic-slide-module--title--1c002";